export default "__VITE_ASSET__CtSTMwcH__"